/* eslint-disable react/prop-types */
const React = require('react');
const { createGlobalStyle } = require('styled-components');

const { colors, fonts } = require('@/theme');
require('@/utils/i18n');

const { black, white } = colors;

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    height: 100%;
  }
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-font-smoothing: antialiased;
    ${fonts.getSubTitle()}
    color: ${black};
    background: ${white};
  }
  body>div, body>div>div  {
    height: 100%;
  }
  input, textarea {
    appearance: none;
    -webkit-appearance: none;
    border-radius: 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    padding-left: 0;
  }
  * {
    -webkit-tap-highlight-color: transparent;
  }
  @font-face {
    font-family: "NeueHaasUnicaPro-Regular";
    font-stretch: normal;
    font-style: normal;
    src: url("/fonts/NeueHaasUnicaProRegular.woff") format("woff"), url("/fonts/NeueHaasUnicaProRegular.woff2") format("woff2");
  }
  @font-face {
    font-family: "NeueHaasUnicaPro-Bold";
    font-stretch: normal;
    font-style: normal;
    src: url("/fonts/NeueHaasUnicaProBold.woff") format("woff"), url("/fonts/NeueHaasUnicaProBold.woff2") format("woff2");
  }
`;

exports.wrapRootElement = ({ element }) => (
  <>
    <GlobalStyle />
    <React.Suspense fallback={null}>
      {element}
    </React.Suspense>
  </>
);
